import React from 'react';

const Form = ({ children, onSubmit }) => {
  return (
    <form className="pb-5 z-0 global-scrollbar" onSubmit={() => onSubmit()}>
      <div className="flex flex-col gap-2 justify-center w-full  items-center  ">{children}</div>
    </form>
  );
};

export default Form;
